import { GDTApiErrors } from '@/types';
import {
  ResponseRankingHistoric,
  ResponseCurrentTeam,
  ResponseChangeTeam,
  RequestChangeTeam,
} from '@/types/team';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

const headers = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export const getDataRanking = axiosErrorHandler(async (date: string) => {
  const url = `${URLs.EQUIPO_11.RANKING}&fecha=${encodeURIComponent(date)}`;
  const response = await axiosGdt.post<ResponseRankingHistoric>(url);
  return response.data;
}, TEXTS.defaultError);

export const getCurrentTeamF11 = axiosErrorHandler(async () => {
  const url = URLs.EQUIPO_11.EQUIPO_ACTUAL;
  const response = await axiosGdt.get<ResponseCurrentTeam | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);

export const postChangeTeam = axiosErrorHandler(
  async (dataChange: RequestChangeTeam) => {
    const url = URLs.EQUIPO_11.HACER_CAMBIO;
    const response = await axiosGdt.post<ResponseChangeTeam>(
      url,
      dataChange,
      headers
    );
    return response.data;
  },
  TEXTS.defaultError
);
